import { render } from "./PageProductGroupEdit.vue?vue&type=template&id=d0b0850c&scoped=true"
import script from "./PageProductGroupEdit.vue?vue&type=script&lang=js"
export * from "./PageProductGroupEdit.vue?vue&type=script&lang=js"

import "./PageProductGroupEdit.vue?vue&type=style&index=0&id=d0b0850c&scoped=true&lang=css"

import exportComponent from "/home/glassplant/agi.co.jp/roots-prod/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d0b0850c"]])

export default __exports__